import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '@/layout/Auth'

import { leaveOrg } from '@/api'
import Modal2 from '@/components/Modal2'
import { Text } from './common'

interface ExitSpaceModalProps {
  open: boolean
  onCancel: () => void
}

const ExitSpaceModal: React.FC<ExitSpaceModalProps> = ({ open, onCancel }) => {
  const navigate = useNavigate()
  const { authInfo } = useContext(AuthContext)
  const orgInfo = authInfo?.orgInfo
  const onSubmit = () => {
    leaveOrg(orgInfo?.id!)
      .then(() => {
        navigate(0)
      })
      .catch((e) => {
        if (e === 4123) {
          Modal2.confirm({
            showCancel: false,
            title: '提示',
            content: (
              <Text sx={{ fontSize: 14 }}>由于您是空间内唯一管理员，须设置一位用户成为管理员后，再次操作退出空间</Text>
            ),
          })
        }
      })
  }

  return (
    <Modal2
      title='提示'
      width={465}
      okText='退出'
      okButtonProps={{ color: 'error' }}
      open={open}
      onCancel={onCancel}
      onOk={onSubmit}
    >
      <Text sx={{ fontSize: 14 }}>确定退出此空间吗？</Text>
      <Text sx={{ fontSize: 14, color: 'error.main', mt: 2 }}>
        退出空间后，您在该空间所产生的数据将不可见，包括不限于：已开通或已购买但未到期的产品应用，站内消息，消息通知策略等。
      </Text>
    </Modal2>
  )
}

export default ExitSpaceModal
